import { Divider, Stack } from '@mui/material';

import { UserIdentityAppModel } from '@api';
import { NoResults } from '@components';

import { PrimarySecondaryLoading } from '@common/ui/PrimarySecondary';
import TableListTitle from '@common/components/TableListTitle';

import useIdentitiesFetch from '@Identities/hooks/use-identities-fetch';

import UsersListItemContainer from '@Identities/components/UsersListItemContainer';
import UsersListItem from '@Identities/organisms/UsersListItem';
import UsersFilters from '@Identities/organisms/UsersFilters';
import TablePagination from '@components/TablePagination';
import TableListTotal from '@common/components/TableListTotal';

export default function UsersPage() {
  const { identitiesList, filterOptions, isFetched, total, pagination, handleOnPageChange } = useIdentitiesFetch();
  if (!isFetched) return <UserListLoading />;

  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
        <UsersFilters {...filterOptions} />
        <TableListTotal totalResults={total} displayedResults={identitiesList.length} />
      </Stack>
      <UsersList identitiesList={identitiesList} />
      <TablePagination pagination={pagination} isLoading={false} onChange={handleOnPageChange} />
    </Stack>
  );
}

function UserListLoading() {
  return <UsersListItemContainer user={<PrimarySecondaryLoading secondary icon iconSpacing={2} />} />;
}

function UsersList({ identitiesList }: { identitiesList: UserIdentityAppModel[] }) {
  if (identitiesList.length === 0) {
    return <NoResults>No identities found</NoResults>;
  }

  return (
    <Stack spacing={2}>
      <Divider />
      <UsersListItemContainer
        user={<TableListTitle>USER</TableListTitle>}
        roles={<TableListTitle>APONO ROLE</TableListTitle>}
        status={<TableListTitle>STATUS</TableListTitle>}
        attributes={<TableListTitle>ATTRIBUTES</TableListTitle>}
        noBorder
      />
      {identitiesList.map((identity) => (
        <UsersListItem key={identity.id} user={identity} />
      ))}
    </Stack>
  );
}
